import React from 'react';
import { keyframes, styled } from 'styled-components';

interface LoaderProps {
  message?: string;
  tableBody?: boolean;
}

const LineLoader: React.FC<LoaderProps> = ({ message, tableBody }) => {
  return (
    <CenteredLoading $tableBody={tableBody} as={tableBody ? 'tr' : undefined}>
      <LoadingContent as={tableBody ? 'td' : undefined}>
        <div>{message}</div>
        <LoadingWrapper>
          <LoadingBar />
        </LoadingWrapper>
      </LoadingContent>
    </CenteredLoading>
  );
};

const CenteredLoading = styled.div.attrs<{ $tableBody?: boolean }>((props) => ({
  $tableBody: props.$tableBody || false,
}))`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  position: ${(props) => (props.$tableBody === true ? 'absolute' : undefined)};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

const LoadingContent = styled.div`
  flex-direction: column;
  display: flex;
  justify-content: center;
  text-align: center;
  background-color: transparent !important;
`;

const LoadingWrapper = styled.div`
  width: 181px;
  height: 4px;
  background-color: #d8d8df !important;
  border-radius: 4px;
  overflow: hidden;
  margin-top: 32px;
  margin-bottom: 2rem;
  margin-left: 1.5rem;
  margin-right: 1.5rem;
  padding: 0 !important;
`;

const loadingBar = keyframes`
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(200%);
  }
`;

const LoadingBar = styled.div`
  position: relative;
  width: 95px;
  height: 4px;
  background: #023e83;
  border-radius: 4px;
  animation-name: ${loadingBar};
  animation-duration: 1.25s;
  animation-iteration-count: infinite;
`;

export default LineLoader;
